import * as t from 'io-ts';
import { stripeCodec, subscriptionCodec } from '@/services/api/resources/subscription/codec';

export type StripeResponse = t.TypeOf<typeof stripeCodec>;
export type Subscription = t.TypeOf<typeof subscriptionCodec>;

export const emptyBillingDetails = () => ({
  company: '',
  email: '',
  address: '',
  city: '',
  zip: '',
  country: 'DE',
  vat: '',
  name: '',
  customerName: '',
});
